import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, fmtINR } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";

export default function Account() {
  const { user, setAuthOpen } = useApp();
  const [orders, setOrders] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    if (!user) { setAuthOpen(true); return; }
    api.get("/orders/mine").then((r) => setOrders(r.data));
  }, [user, setAuthOpen]);

  if (!user) {
    return <div className="mx-auto max-w-3xl px-4 py-20 text-center text-white/60">Please sign in to view orders.</div>;
  }

  return (
    <div data-testid="account-page" className="mx-auto max-w-5xl px-4 sm:px-6 py-10">
      <p className="mono-label text-blue-400 mb-2">Account</p>
      <h1 className="font-display text-3xl sm:text-4xl tracking-tight mb-2">My orders</h1>
      <p className="text-white/60 text-sm mb-8 font-mono">{user.email || user.phone}</p>

      {orders.length === 0 ? (
        <div className="border border-white/10 bg-zinc-950 p-10 text-center">
          <p className="text-white/60 mb-4">You haven't placed any orders yet.</p>
          <Button asChild className="bg-blue-600 hover:bg-blue-500 rounded-none"><Link to="/shop">Browse displays</Link></Button>
        </div>
      ) : (
        <div className="border border-white/10 bg-zinc-950 divide-y divide-white/10">
          {orders.map((o) => (
            <button
              key={o.id}
              data-testid={`order-row-${o.id}`}
              onClick={() => nav(`/order/${o.id}`)}
              className="w-full text-left p-5 hover:bg-white/5 transition-colors flex items-center justify-between gap-4"
            >
              <div>
                <p className="font-mono text-xs text-white/50">#{o.id.slice(0, 8)}</p>
                <p className="font-display mt-1">{o.items.length} item{o.items.length !== 1 ? "s" : ""}</p>
                <p className="text-xs text-white/50 mt-1">{new Date(o.created_at).toLocaleString("en-IN")}</p>
              </div>
              <div className="text-right">
                <span className={`mono-label px-2 py-0.5 border ${o.status === "paid" ? "border-emerald-500/40 text-emerald-400" : "border-yellow-500/40 text-yellow-400"}`}>
                  {o.status}
                </span>
                <p className="font-mono text-lg mt-2">{fmtINR(o.total_inr)}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
